// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3PdBz","errorLogs":"EditorFooter_errorLogs__g5SaW"};